import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Toolsschology() {
  return (
    <section className="tools-schology p-100">
      <Container>
        <div className="tools-box">
          <Row className="mb-4 mb-md-5">
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={9}
              xxl={8}
              className="m-auto text-center"
            >
              <h2 style={{ color: "#111322" }}>
                <span className="purple-box">Tech</span> Powering Education
              </h2>
              <h3 style={{ color: "#111322" }}>
                The Tools TekRevol Used to Drive Schology’s Success
              </h3>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={10}
              xxl={10}
              className="m-auto text-center"
            >
              <div className="tools-main-sec">
                <div className="tools-item">
                  <div className="box">
                    <h5>Frontend</h5>
                    <StaticImage
                      src="../../../images/case-studies/schology/react-icon.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={76}
                      height={72}
                    />
                    <p>React</p>
                  </div>
                </div>
                <div className="tools-item">
                  <div className="box">
                    <h5>Backend</h5>
                    <StaticImage
                      src="../../../images/case-studies/schology/python-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={69}
                      height={69}
                    />
                    <p>Python</p>
                  </div>
                </div>
                <div className="tools-item">
                  <div className="box">
                    <h5>Database</h5>
                    <StaticImage
                      src="../../../images/case-studies/schology/mongo-db.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={52}
                      height={75}
                    />
                    <p>MongoDB</p>
                  </div>
                </div>
                <div className="tools-item">
                  <div className="box">
                    <h5>Cloud Services</h5>
                    <StaticImage
                      src="../../../images/case-studies/schology/aws-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={75}
                      height={73}
                    />
                    <p>AWS for scalability</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Toolsschology;
